import { Link, Outlet, useRouterState } from '@tanstack/react-router';

const tabs = [
  { to: '/admin/invitations', label: 'Invitations' },
  { to: '/admin/onboarding', label: 'Onboarding' },
  { to: '/admin/plans', label: 'Plans' },
  { to: '/admin/partners', label: 'Partners' },
  { to: '/admin/tenants', label: 'Tenants' },
  { to: '/admin/audit', label: 'Audit log' },
];

export function AdminLayout() {
  const path = useRouterState({ select: (s) => s.location.pathname });
  return (
    <div className="mx-auto max-w-7xl px-6 py-8">
      <h1 className="text-2xl font-semibold">Admin</h1>
      <p className="text-sm text-slate-600">Platform-wide controls. Super-admin / admin only.</p>
      <nav className="mt-4 mb-6 flex flex-wrap gap-1 border-b border-slate-200">
        {tabs.map((t) => {
          const active = path.startsWith(t.to);
          return (
            <Link
              key={t.to}
              to={t.to}
              className={`px-4 py-2 text-sm border-b-2 -mb-px transition ${
                active
                  ? 'border-brand-600 text-brand-700'
                  : 'border-transparent text-slate-600 hover:text-brand-700'
              }`}
            >
              {t.label}
            </Link>
          );
        })}
      </nav>
      <Outlet />
    </div>
  );
}
